import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import { variables } from 'src/Tenants';
import { KeyPickupStatus } from '../../types';
import CalcomScheduledBadge from '../CalcomScheduledBadge/CalcomScheduledBadge';
import CalcomCancelledBadge from '../CalcomCancelledBadge/CalcomCancelledBadge';
import './key-pickup-status-badge.scss';

interface KeyPickupStatusBadgeProps {
  status: KeyPickupStatus;
  calcomBookingStatus: string | null;
  calcomBookingUid: string | null;
  homeOwnerFullName: string | null;
}

const KeyPickupStatusBadge = ({
  status,
  calcomBookingStatus,
  calcomBookingUid,
  homeOwnerFullName,
}: KeyPickupStatusBadgeProps) => {
  if (calcomBookingStatus?.toLowerCase() === 'cancelled') {
    return <CalcomCancelledBadge calcomBookingUid={calcomBookingUid} />;
  }

  if (status === 'HandedOff') {
    return (
      <span className="unit-status unit-status--handed-off">
        <FontAwesomeIcon glyph="check-circle" weight="solid" size="small" />
        Key Pickup Has Been Complete
      </span>
    );
  }

  if (status === 'Booked') {
    return <CalcomScheduledBadge calcomBookingUid={calcomBookingUid} />;
  }

  if (status === 'InviteSent') {
    return (
      <span className="unit-status-invite">
        <span className="unit-status unit-status--invite-sent">
          <FontAwesomeIcon glyph="paper-plane" weight="solid" size="small" />
          Invite sent
        </span>
        <span className="unit-status-invite-note">
          Booking link emailed — waiting for the homeowner to pick a time from
          your Cal.com availability.
        </span>
      </span>
    );
  }

  if ((homeOwnerFullName?.trim() ?? '') === '') {
    const suiteLower: string = variables.Suite.toLowerCase();

    return (
      <span className="unit-status-with-note">
        <span className="unit-status unit-status--no-homeowner">
          <FontAwesomeIcon
            glyph="exclamation-circle"
            weight="solid"
            size="small"
          />
          No homeowner available
        </span>
        <span className="unit-status-note">
          This {suiteLower} doesn&apos;t have a primary homeowner yet. Add one on
          the {suiteLower}, then come back and refresh this page.
        </span>
      </span>
    );
  }

  return (
    <span className="unit-status unit-status--pending">
      Ready to be invited
      <FontAwesomeIcon glyph="user-plus" weight="solid" size="small" />
    </span>
  );
};

export default KeyPickupStatusBadge;
